export default __webpack_public_path__ + "static/media/working4.2ac72f7e.png";